export default __webpack_public_path__ + "static/assets/02ef4715f4a8905e938ccf28330d3486.png";